import { render, staticRenderFns } from "./claimsSuccess.vue?vue&type=template&id=526632e8&scoped=true&"
import script from "./claimsSuccess.vue?vue&type=script&lang=js&"
export * from "./claimsSuccess.vue?vue&type=script&lang=js&"
import style0 from "./claimsSuccess.vue?vue&type=style&index=0&id=526632e8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526632e8",
  null
  
)

export default component.exports